export default __webpack_public_path__ + "f65f24056cd61ee8fddddd7f3e90ad77.png";